import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { User } from '../../graphql/auth';
import { gqlLoggedInUser, setMe } from '../../graphql/auth/getMe';
import { onLoginComplete } from './loginUser.api';

interface RegisterUserVars {
  data: {
    email: string,
    first_name: string,
    last_name: string,
    password: string,
    password_confirmation: string,
    cellphone: string,
    cellphone_code: string,
    email_opt_out: boolean,
    sms_opt_out: boolean,
  }
}

interface RegisterUserData {
  registerUser: {
    access_token: string,
    user: User,
  }
}

export const REGISTER_USER_MUTATION = gql`
    mutation registerUser($data: RegisterUserInput) {
        registerUser(data: $data) {
            access_token
            user {
                ${gqlLoggedInUser}
            }
        }
    }
`;

export const registerUser = () => useMutation<RegisterUserData, RegisterUserVars>(
  REGISTER_USER_MUTATION,
  {
    update: (proxy, response) => {
      const me = response.data!.registerUser.user;
      setMe(proxy, me);
    },
    onCompleted: (response) => {
      onLoginComplete(response.registerUser.access_token)
    }
  }
);

export default registerUser;
